import React from 'react';
import { Container, Box, Card, CardMedia, Typography, Button, Grid } from '@mui/material';
import image1 from '../images/image1.png';
import image2 from '../images/image2.jpeg';
import image3 from '../images/image3.jpeg';
import image4 from '../images/image4.jpeg';
import image5 from '../images/image5.jpeg';
import image6 from '../images/image6.jpeg';
import backgroundImage from '../images/background.jpg'; // Add this import
import BrushIcon from '@mui/icons-material/Brush';
import { PRICES } from '../resources/Constants';
import { styles } from './MuiStyles';
import BookPopup from './BookPopup';
import ImagePopup from './ImagePopup';

function LandingPage({}) {
  const images = [image1, image2, image3, image4, image5, image6];
  const [isBookPopupOpen, setIsBookPopupOpen] = React.useState(false);
  const [selectedImage, setSelectedImage] = React.useState(null); // Add this state

  const handleOpenBookPopup = () => {
    setIsBookPopupOpen(true);
  };

  const handleCloseBookPopup = () => {
    setIsBookPopupOpen(false);
  };

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseImagePopup = () => {
    setSelectedImage(null);
  };

  return (
    <Box sx={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundColor: 'rgba(255, 240, 245, 0.8)', // Light pink with opacity
      backgroundBlendMode: 'overlay',
      minHeight: '100vh',
      paddingTop: 4,
      paddingBottom: 4
    }}>
      <Container maxWidth="sm">
        <Box sx={{ mt: 4, mb: 2, textAlign: 'center' }}>
          <Typography variant="h3" component="h1" sx={styles.welcomeMessage}>
            Welcome to Pristine Polish!
          </Typography>
          <Typography variant="body1" sx={styles.welcomeDescription}>
            We are a Phoenix-based mobile nail salon. You book, and we will come to you!
          </Typography>
        </Box>
        <Box sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
          <Typography variant="h6" component="h3" sx={styles.pricesTitle}>
            Here are our prices:
          </Typography>
          {Object.entries(PRICES).map(([service, price]) => (
            <Typography key={service} variant="body1" sx={styles.priceItem}>
              {service}: {typeof price === 'number' ? `$${price}` : price}
            </Typography>
          ))}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, mb: 2 }}>
          <Button
            variant="contained"
            size="large"
            startIcon={<BrushIcon />}
            sx={styles.bookNowButton}
            onClick={handleOpenBookPopup}
          >
            Book Now
          </Button>
        </Box>
        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Typography variant="body2" sx={styles.spanishMessage}>
            ¡Hablamos español!
          </Typography>
        </Box>
        <Box sx={{ flexGrow: 1, mb: 4 }}>
          <Grid container spacing={2}>
            {images.map((image, index) => (
              <Grid item xs={6} sm={4} key={index}>
                <Card sx={styles.imageCard} onClick={() => handleImageClick(image)}>
                  <CardMedia
                    component="img"
                    sx={styles.cardMedia}
                    image={image}
                    alt={`Image ${index + 1}`}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
        <BookPopup open={isBookPopupOpen} onClose={handleCloseBookPopup} />
        <ImagePopup image={selectedImage} onClose={handleCloseImagePopup} />
      </Container>
    </Box>
  );
}

export default LandingPage;
